import { disputesActionTypes } from '../disputes-action-types';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { getFormattedDate, makeSearchParams } from '../../../utils/utilities';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import { DateField, IAction, IDisputesPaginationData, IState } from '../disputes-interfaces';
import { getFormattedRefundFormFields } from '../../../constants/refund/refund-form';
import { formikErrorHandler } from '../../../utils/formikUtils';
import download from 'downloadjs';
import { ISelectorData } from '../../../components/application/NewApplication';
import * as React from 'react';
import { MRT_PaginationState, MRT_SortingState } from 'material-react-table';
import { getFormattedMatchDisputeFormFields, MatchDisputesReturnTypes } from '../../../constants/dispute/dispute-form';
import { GET, POST } from '../../store-helper';
import { IDisputesFilters } from '../../../components/disputes/all_disputes/DisputesFilterSection';

export const fetchDisputes = async (params: IDisputesFilters): Promise<IDisputesPaginationData> => {
    try {

        const { disputes } = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes`,
            params,
        });

        return disputes;

    } catch (error) {
        sendSentryMessage({ name: `GET Fetch search filter list error`, context: error });
    }
};

export const fetchDisputeDetails = async (dispatch: React.Dispatch<IAction>, id: string): Promise<void> => {
    dispatch({ type: disputesActionTypes.SET_DISPUTE_DETAILS_LOADING, payload: true });
    try {
        const res = await axios.get(`${BASE_URL.PAYMENTS}/Disputes/${id}/queue-item`);
        const lists = await getList(dispatch);
        const isProviderName = lists?.providers?.some(el => el?.value === res?.data?.providerName);
        dispatch({ type: disputesActionTypes.FETCH_DISPUTES_DETAILS, payload: res?.data || [] });
        dispatch({ type: disputesActionTypes.SET_IS_PROVIDER_NAME, payload: isProviderName });
    } catch (error) {
        sendSentryMessage({ name: `GET Fetch search filter list error`, context: error });
        dispatch({ type: disputesActionTypes.FETCH_DISPUTES_DETAILS, payload: null });
    }
};

export const setDisputeQueueItemDetailsToDefault = (dispatch: React.Dispatch<IAction>): void => {
    dispatch({ type: disputesActionTypes.SET_DISPUTE_DETAILS_TO_DEFAULT });
};

export const setDateTime = (dispatch: React.Dispatch<IAction>, state: IState, value: string[] | Date[], field: DateField): void => {
    try {
        const from = value[0] ? getFormattedDate(value[0], 'yyyy-MM-dd HH:mm:ss') : null;
        const to = value[1] ? getFormattedDate(value[1], 'yyyy-MM-dd HH:mm:ss') : null;

        if (field === DateField.authorizationDate && (state.from !== from || state.to !== to)) {
            dispatch({ type: disputesActionTypes.SET_DATETIME, payload: { from, to, field }});
        }

        if (field === DateField.requestDate && (state.requestFrom !== from || state.requestTo !== to)) {
            dispatch({ type: disputesActionTypes.SET_DATETIME, payload: { requestFrom: from, requestTo: to, field }});
        }

        if (field === DateField.createdDate && (state.createdFrom !== from || state.createdTo !== to)) {
            dispatch({ type: disputesActionTypes.SET_DATETIME, payload: { createdFrom: from, createdTo: to, field }});
        }

        if (field === DateField.disputeDetailsCreatedDate && (state.disputeDetailsCreatedFrom !== from || state.disputeDetailsCreatedTo !== to)) {
            dispatch({ type: disputesActionTypes.SET_DATETIME, payload: { disputeDetailsCreatedFrom: from, disputeDetailsCreatedTo: to, field }});
        }

        // if (field === DateField.disputeQueueCreatedDate && (state.disputeQueueCreatedFrom !== from || state.disputeQueueCreatedTo !== to)) {
        //     dispatch({ type: disputesActionTypes.SET_DATETIME, payload: { disputeQueueCreatedFrom: from, disputeQueueCreatedTo: to, field }});
        // }

    } catch (error) {
        dispatch({ type: disputesActionTypes.SET_DATETIME_ERROR });
    }
};

export const setTimezone = (dispatch: React.Dispatch<IAction>, state: IState, value: string): void => {
    try {
        if (state.timezone !== value) {
            dispatch({ type: disputesActionTypes.SET_TIMEZONE, payload: value });
        }
    } catch (error) {
        dispatch({ type: disputesActionTypes.SET_TIMEZONE_ERROR });
    }
};

export const setPagination = (dispatch: React.Dispatch<IAction>, state: IState, value: MRT_PaginationState): void => {
    try {
        if (state.pageNumber != value.pageIndex || state.pageSize != value.pageSize) {
            dispatch({ type: disputesActionTypes.SET_PAGINATION, payload: {
                    pageNumber: value.pageIndex,
                    pageSize: value.pageSize
                }});
        }
    } catch (error) {
        dispatch({ type: disputesActionTypes.SET_PAGINATION_ERROR });
    }
};

export const setSorting = (dispatch: React.Dispatch<IAction>, value: MRT_SortingState): void => {
    dispatch({ type: disputesActionTypes.SET_SORTING, payload: value });
};

export const exportCSVDisputes = async (dispatch: React.Dispatch<IAction>, searchParams: IDisputesFilters): Promise<void> => {
    try {
        dispatch({ type: disputesActionTypes.SET_DISPUTES_EXPORT_LOADING, payload: true });

        const data = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/export`,
            params: searchParams
        });

        if (data) {
            const blob = new Blob([data], { type: 'text/csv' });
            download(blob, 'Disputes.csv');
        }
    } catch (e) {
        console.log(e);
    } finally {
        dispatch({ type: disputesActionTypes.SET_DISPUTES_EXPORT_LOADING, payload: false });
    }
};

export const getDisputesQueryParams = (state: IState, isExport: boolean = false, chosenMerchant: null | string, isMatch: boolean | null = null): { [p: string]: string | string[] | number | boolean } => {
    // if (!chosenMerchant && !searchParams?.mid) {
    //     const merchantId = localStorage.getItem('chosenMerchant');
    //     if (merchantId) {
    //         return;
    //     }
    // }

    const params: { [key: string]: string | string[] | number | boolean } = {};
    if (state.query) {
        params.query = state.query;
    }

    if (isMatch !== null) {
        params.isMatch = isMatch;
    }

    if (state.from && state.to) {
        params.from = state.from;
        params.to = state.to;
    }

    if (state.requestFrom && state.requestTo) {
        params.requestFrom = state.requestFrom;
        params.requestTo = state.requestTo;
    }

    if (state.createdFrom && state.createdTo) {
        params.createdFrom = state.createdFrom;
        params.createdTo = state.createdTo;
    }

    if (state.timezone) {
        params.timezone = state.timezone;
    }
    if (state.pageSize) {
        params.pageSize = isExport ? state.totalItemCount : state.pageSize;
    }
    if (state.pageNumber || state.pageNumber === 0) {
        params.pageNumber = isExport ? 1 : state.pageNumber + 1;
    }
    if (state.sorting.length > 0) {
        params.sortField = state.sorting[0].id;
    }
    params.sort = state.sorting?.[0] === undefined || state.sorting?.[0]?.desc ? 'desc' : 'asc';

    if (isExport) {
        params.responseType = 'blob';
    }

    if (chosenMerchant !== null && chosenMerchant.length > 0) {
        params.mid = chosenMerchant;
    }

    if (state.selectedProviderName.length > 0) {
        params.providerName = state.selectedProviderName;
    }

    if (state.selectedCardBrand.length > 0) {
        params.cardBrand = state.selectedCardBrand;
    }
    if (state.selectedDisputeType.length > 0) {
        params.stage = state.selectedDisputeType;
    }

    if (state.isWebhook) {
        params.isWebhook = state.isWebhook;
    }

    if (state.isFileImported) {
        params.isFileImported = state.isFileImported;
    }

    if (state.isManualInserted) {
        params.isManualInserted = state.isManualInserted;
    }

    return params;
};

export const setDefaultValues = (dispatch: React.Dispatch<IAction>): void => {
    dispatch({ type: disputesActionTypes.SET_DEFAULT_VALUES });
};

export const fetchDisputesManagementSystems = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
    try {

        const data = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/dispute-management-system`,
        });
        if (data) {
            dispatch({ type: disputesActionTypes.FETCH_DISPUTES_MANAGEMENT_SYSTEM, payload: data });
        }

    } catch (error) {
        sendSentryMessage({ name: `GET Fetch disputes management systems list error`, context: error });
    }
};

export const fetchKountStatusCodes = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
    try {

        const data = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/kount-status-codes`,
        });

        if (data) {
            dispatch({ type: disputesActionTypes.FETCH_KOUNT_STATUS_CODES, payload: data });
        }

    } catch (error) {
        sendSentryMessage({ name: `GET Fetch disputes management systems list error`, context: error });
    }
};

export const fetchDisputesCardBrands = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
    try {
        const data = await GET({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/dispute-card-brands`,
        });

        if (data) {
            dispatch({ type: disputesActionTypes.FETCH_DISPUTES_CARD_TYPES, payload: data });
        }

    } catch (error) {
        sendSentryMessage({ name: `GET Fetch disputes card types list error`, context: error });
    }
};

export const deleteQueue = async (id: string): Promise<void> => {
    return await axios.delete(`${BASE_URL.PAYMENTS}/Disputes/${id}/queue`);
};

export const setRefund = async (formik: any, onSuccess: () => void, onError: () => void): Promise<void> => {
    try {
        if (!formik.isValid) return;
        const body = getFormattedRefundFormFields(formik.values);
        await axios.put(`${BASE_URL.PAYMENTS}/Disputes/pre`, body);
        onSuccess();
    } catch (e) {
        console.log('setRefund error', e.response);
        if (e.response?.data?.errors) {
            formikErrorHandler({ formik, data: e.response?.data?.errors });
            return;
        }
        onError();
    }
};

export const clearDisputeFilters = (dispatch: React.Dispatch<IAction>): void => {
    dispatch({ type: disputesActionTypes.CLEAR_FILTER });
};

export const fetchDisputeActivities = async (transactionId: string): Promise<void> => {
    const params = { transactionId };

    return await axios
        .get(`${BASE_URL.PAYMENTS}/Disputes/dispute-activities`, {
            params,
            paramsSerializer: params => makeSearchParams(params)
        })
        .then(res => res?.data);
};

export const uploadFile = async (file, provider, autoMatch, id): Promise<void> => {
    const formData = new FormData();
    formData.append('file', file);
    return await axios.post(`${BASE_URL.PAYMENTS}/Disputes/load-file?source=${provider}&autoMatch=${autoMatch}&id=${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const getDisputeMatchQueryParams = (data: MatchDisputesReturnTypes): { [p: string]: string | number | boolean } => {
    const params: { [key: string]: string | number | boolean } = {};

    params.disputeQueueItemId = data?.disputeQueueItemId;
    params.transactionId = data?.transactionId;

    if (data?.KountStatusCode) {
        params.KountStatusCode = data?.KountStatusCode;
    }

    if (data?.comments) {
        params.comments = data?.comments;
    }

    if (data?.amountToRefund) {
        params.amountToRefund = data?.amountToRefund;
    }

    if (data?.issueRefund) {
        params.issueRefund = true;
    }

    return params;
};

export const matchDispute = async (
  dispatch: React.Dispatch<IAction>,
  formik: any,
  body: MatchDisputesReturnTypes,
  onSuccess: () => void,
  onError: (error: any) => void,
  setError: (error: string) => void,
): Promise<void> => {
    try {
        dispatch({ type: disputesActionTypes.SET_DISPUTE_MATCH_LOADING, payload: true });
        const params = {
          ...body,
          ...getFormattedMatchDisputeFormFields(formik.values),
        };

        const bodyParams = getDisputeMatchQueryParams(params);
        const { data } = await axios.post(`${BASE_URL.PAYMENTS}/Disputes/match`, bodyParams);
        dispatch({ type: disputesActionTypes.SET_DISPUTE_MATCH_LOADING, payload: false });

        if (!data?.success) {
            setError(data?.message);
            dispatch({ type: disputesActionTypes.SET_DISPUTE_MATCH_LOADING, payload: false });
        } else {
            onSuccess();
        }

    } catch (e) {
        console.log('match error', e.response);
        dispatch({ type: disputesActionTypes.SET_DISPUTE_MATCH_LOADING, payload: false });
        onError(e.response?.data);
    }
};

export const alertKount = async (dispatch, body, onSuccess, onError): Promise<void> => {
    dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: true });
    try {
        await axios.post(`${BASE_URL.PAYMENTS}/Disputes/alert-kount`, body);
        dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: false });

        onSuccess();
    } catch (e) {
        console.log('match error', e.response);
        dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: false });
        onError(e.response?.data);
    }
};

export const alertMyRcvr = async (dispatch, body, onSuccess, onError): Promise<void> => {
    dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: true });
    try {
        await axios.post(`${BASE_URL.PAYMENTS}/Disputes/alert-myrcvr`, body);
        dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: false });

        onSuccess();
    } catch (e) {
        console.log('match error', e.response);
        dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: false });
        onError(e.response?.data);
    }
};

export const alertChargeblast = async (dispatch, body, onSuccess, onError): Promise<void> => {
    dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: true });
    try {
        await axios.post(`${BASE_URL.PAYMENTS}/Disputes/alert-chargeblast`, body);
        dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: false });

        onSuccess();
    } catch (e) {
        console.log('match error', e.response);
        dispatch({ type: disputesActionTypes.ALERT_KOUNT_LOADING, payload: false });
        onError(e.response?.data);
    }
};

interface IDisputesList {
    providers: ISelectorData[];
    statuses: ISelectorData[];
    types: ISelectorData[];
}

export const getList = async (dispatch: React.Dispatch<IAction>): Promise<IDisputesList> => {
    try {
        const res = await axios.get(`${BASE_URL.PAYMENTS}/Transactions/list`);

        const lists: IDisputesList = {
            providers: [],
            statuses: [],
            types: [],
        };

        const disputesLists = ['providers', 'statuses', 'types'];

        disputesLists?.forEach(item => {
            if (res?.data && Array.isArray(res?.data[item])) {
                lists[item] = res?.data[item].map(el => ({
                    value: el,
                    label: el
                }));
            }
        });

        dispatch({ type: disputesActionTypes.FETCH_DISPUTE_DETAILS_LISTS, payload: lists });
        return lists;
    } catch (e) {
        console.log('disputes lists error', e.response);
    }
};

export const archivatingDispute = async (dispatch: React.Dispatch<IAction>, disputeId: string, onSuccess: () => void, onError: () => void): Promise<void> => {
    dispatch({ type: disputesActionTypes.SET_ARCHIVATING_DISPUTE_LOADING, payload: true });
    try {
        await axios.post(`${BASE_URL.PAYMENTS}/Disputes/archive?disputeId=${disputeId}`);
        dispatch({ type: disputesActionTypes.SET_ARCHIVATING_DISPUTE_LOADING, payload: false });

        onSuccess();
    } catch (e) {
        console.log('match error', e.response);
        dispatch({ type: disputesActionTypes.SET_ARCHIVATING_DISPUTE_LOADING, payload: false });
        onError();
    }
};

export const disputeReverse = async (disputeId: string, onSuccess: () => void, onError: () => void): Promise<void> => {
    try {
        await POST({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/reverse?disputeId=${disputeId}`,
        });

        onSuccess();
    } catch (e) {
        console.log('disputeReverse error', e);
        onError();
    }
};

interface ISetReconcileDisputes {
    items: { disputeQueueItemId: string, transactionId: string }[];
    onSuccess: () => void;
    onError: (errorMessage: string) => void;
}

export const setReconcileDisputes = async ({
    items,
    onSuccess,
    onError,
}: ISetReconcileDisputes): Promise<void> => {
    try {
        const data = await POST({
            pathname: `${BASE_URL.PAYMENTS}/Disputes/reconcile`,
            body: { items },
        });
        console.log('data', data);
        if (data?.errors?.length) {
            onError(data?.message);
        } else {
            onSuccess();
        }
    } catch (e) {
        console.log('setReconcileDisputes error', e.response);
    }
};
